var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app",attrs:{"id":"app"}},[(_vm.isAppLoading)?_c('main',{staticClass:"app__loading"},[_c('BaseSpinner',{attrs:{"variant":"primary"}}),_c('span',[_vm._v("Loading")])],1):_c('main',[_c('router-view')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }